import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { USERS_LIST } from 'src/app/shared/data/users-mock-list';

@Component({
  selector: 'sm-all-unblock-request',
  templateUrl: './all-unblock-request.component.html',
  styleUrls: ['./all-unblock-request.component.scss']
})
export class AllUnblockRequestComponent implements OnInit {
  @ViewChild('customMessage', {static: true})
  messageTemplate!: TemplateRef<HTMLElement>;
  tableDisplayColumns: ITableColumnHeader[] = []
  requestList: any[] = [];

  constructor() { 
    this.requestList = USERS_LIST;
  }

  ngOnInit(): void {
    this.tableDisplayColumns = [
      {
        columnName: "name",
        columnProperty: "name"
      },
      {
        columnName: "subject",
        columnProperty: "location"
      },
      {
        columnName: "message",
        columnProperty: "type",
        columnTemplate: this.messageTemplate
      }
    ];
  }

}
